import React from "react";
import { langCodes } from "@/utils/countries";

interface HeadLinksProps extends React.PropsWithChildren {
    pathname?: string;
    canonicalUrl?: string;
}

const createOwnCanonicalUrl = (url, hostname) => {
    const parsedUrl = new URL(url);
    return `${hostname}${parsedUrl.pathname}`;
}

const HeadLinks: React.FC<HeadLinksProps> = ({ pathname, canonicalUrl }) => {
    let hostname = '';

    if (process.env.GATSBY_SITE_URL) {
        hostname = process.env.GATSBY_SITE_URL;
    };

    if (canonicalUrl) {
        canonicalUrl = createOwnCanonicalUrl(canonicalUrl, hostname);
    } else {
        canonicalUrl = `${hostname}${pathname}`;
    }

    const canonicalLink = (
        <link
            key="canonical"
            rel="canonical"
            href={canonicalUrl}
        />
    );

    const alternateLinks = langCodes.map(({ domain, lang }) => {

        if (`https://${domain}` === hostname) {
            return null;
        }

        const isDefault = domain === 'ortorex.com';
        const hreflang = isDefault ? 'x-default' : lang;
        const href = `https://${domain}${pathname}`;

        return (
            <link
                key={domain}
                rel="alternate"
                hrefLang={hreflang}
                href={href}
            />
        )
    });

    return (
        <>
            {canonicalLink}
            {alternateLinks}
        </>
    )
};

export default HeadLinks;
